<template>
  <div class="row row-equal">
    <div class="flex xl12 xs12">
      <div class="row">
        <div class="flex xs12 md6">
          <va-card :title="$t('dashboard.info.subscriptionLimits')">
            <div class="row row-separated">
              <div class="flex xs4">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.primary}">{{this.limitStats.locationsCount}} <span class="limitTo">/ {{ $t('dashboard.info.unlimited') }}</span></p>
                <p class="text--center mb-1" @click="toLocations"><span class="clickPointer">{{ $t('dashboard.info.locations') }}</span></p>
              </div>
              <div class="flex xs4">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.info}">{{this.limitStats.ticketsCount}} <span class="limitTo">/ {{limitByType('ticket')}}</span></p>
                <p class="text--center no-wrap mb-1">{{ $t('dashboard.info.ticketsThisMonth') }}</p>
              </div>
              <div class="flex xs4">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.primary}">{{this.limitStats.appSubscriptionCount}}</p>
                <p class="text--center no-wrap mb-1" @click="toAppSubscriptions"><span class="clickPointer">{{ $t('dashboard.info.charges') }}</span></p>
              </div>
            </div>
          </va-card>
        </div>
        <div class="flex xs12 md6">
          <va-card :title="$t('dashboard.info.quickClientsStats')">
            <div class="row row-separated">
              <div class="flex xs3">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.primary}">{{this.limitStats.activeClientsCount}}</p>
                <p class="text--center mb-1" @click="toLocations"><span class="clickPointer">{{ $t('dashboard.info.active') }}</span></p>
              </div>
              <div class="flex xs3">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.warning}">{{this.limitStats.todayClientsCount}}</p>
                <p class="text--center mb-1" @click="toClients"><span class="clickPointer">{{ $t('dashboard.info.today') }}</span></p>
              </div>
              <div class="flex xs3">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.info}">{{this.limitStats.thisWeekClientsCount}}</p>
                <p class="text--center no-wrap mb-1">{{ $t('dashboard.info.thisWeek') }}</p>
              </div>
              <div class="flex xs3">
                <p class="display-2 mb-1 text--center" :style="{color: this.$themes.warning}">{{this.limitStats.thisMonthClientsCount}}</p>
                <p class="text--center mb-1" @click="toClients"><span class="clickPointer">{{ $t('dashboard.info.thisMonth') }}</span></p>
              </div>
            </div>
          </va-card>
        </div>
        <!--        <div class="flex xs12 md12" v-if="this.verticalBarChartData !== null">
          <va-card :title="$t('dashboard.info.quickProfitStats')">
            <va-chart :data="verticalBarChartData" :options="{
              responsive: true,
              plugins: {
                legend: {
                  position: 'left',
                }
              },
              scales: {
                x: {
                  type: 'category',
                  ticks: {
                    callback: function(value, index, values) {
                      // Display '0' if all data points are zero, otherwise display the default label
                      return values.every(val => val === 0) ? '0' : value;
                    }
                  }
                },
                y: {
                  ticks: {
                    min: 0, // Set minimum value for y-axis
                    // stepSize: 23 / 10 // Optional: Adjust step size if needed
                  }
                }
              }
            }" type="vertical-bar"/>
          </va-card>
        </div>-->
      </div>
    </div>
    <div class="flex xs12 md6 xl6">
      <va-card
        stripe="primary"
        :title="$t('dashboard.info.yourApplicationsUrls')"
      >
        <p>{{ $t('dashboard.info.employeesApplication') }} : <a target="_blank" :href="'https://'
          + this.$store.getters.namespace
          + this.$store.getters.authenticationData.employeeUrl">https://{{this.$store.getters.namespace
          + this.$store.getters.authenticationData.employeeUrl}}</a></p>
        <p>{{ $t('dashboard.info.clientsApplication') }} : <a target="_blank" :href="'https://'
          + this.$store.getters.namespace
          + this.$store.getters.authenticationData.clientUrl">https://{{this.$store.getters.namespace
          + this.$store.getters.authenticationData.clientUrl}}</a></p>

        {{ $t('dashboard.info.setYourLogo') }} <br/>
        <va-button @click="toAppSettings" color="primary">
          {{ $t('dashboard.info.applicationSettings') }}
        </va-button>
      </va-card>
    </div>
    <div class="flex xs12 md6 xl6">
      <va-card
        stripe="info"
        :title="$t('dashboard.info.needHelp')"
      >
        {{ $t('dashboard.info.getLookAt') }} <a href="https://valet.live/docs/" target="_blank">valet.live/docs documentation</a> {{ $t('dashboard.info.toSeeHowEasy') }}
        <div class="row mt-3">
          <va-button color="info" href="https://valet.live/docs/" target="_blank">
            {{ $t('dashboard.info.goToDoc') }}
          </va-button>

          <!--          <va-button color="success">-->
          <!--            Helpdesk-->
          <!--          </va-button>-->
        </div>
      </va-card>
    </div>
    <div class="flex xs12 md6 xl6">
      <va-card
        stripe="info"
        :title="$t('dashboard.info.activePrepaidPacks')"
      >
        <p v-for="item in subscriptionPacks" :key="item.subscriptionPackId">
          <strong>{{item.name}}</strong>
          - <strong>{{item.amount}} / {{item.currentAmount}} {{ $t('dashboard.info.tickets') }}</strong>
          - <strong>{{item.period}} / {{ $t('dashboard.info.months') }}</strong>
          - <strong>{{item.price}}€ / {{ $t('dashboard.info.ticket') }}</strong>
        </p>
        <va-button @click="toSubscriptions" color="info">
          {{ $t('dashboard.info.purchaseNewPack') }}
        </va-button>
      </va-card>
    </div>
    <div class="flex xs12 md6 xl6">
      <va-card
        stripe="warning"
        :title="$t('dashboard.info.yourSubscription')"
      >
        <div v-if="this.$store.getters.localUserSubscription === null ||
          this.$store.getters.localUserSubscription.isFree" class="app-navbar__center lg5 md4">
          <span
            class="app-navbar__text"
            :style="{color: this.$themes.gray}"
          >
            {{this.$store.getters.subscription === null ? $t('dashboard.info.subscribeToPlan') : $t('dashboard.info.upgradeYourPlan')}} &nbsp;
          </span>
          <va-button
            @click="toSubscriptions"
            color="#000000"
            class="app-navbar__button"
            :icon="this.$store.getters.subscription === null ? 'fa fa-unlock' : 'fa fa-star'"
          >
            {{this.$store.getters.subscription === null ? $t('dashboard.info.subscribe') : $t('dashboard.info.upgrade')}}
          </va-button>
        </div>
        <div v-if="this.$store.getters.localUserSubscription !== null &&
          !this.$store.getters.localUserSubscription.isFree" class="app-navbar__center lg5 md4">
          <span v-if="!this.$store.getters.localCompanySubscription.isExpired && isDayAfter(this.$store.getters.localCompanySubscription.activeTo)"
            class="app-navbar__text"
            :style="{color: this.$themes.gray}"
          >
            {{ $t('dashboard.info.yourPlan') }} <strong><a @click="toSubscriptions">{{this.$store.getters.localUserSubscription.name}}</a></strong> {{ $t('dashboard.info.hasExpiredOn') }}
            <strong>{{this.$store.getters.localCompanySubscription.activeTo | moment("MMMM Do YYYY")}}</strong>, {{ $t('dashboard.info.pleaseConsider') }}
          </span>

          <span v-if="!this.$store.getters.localCompanySubscription.isExpired && !isDayAfter(this.$store.getters.localCompanySubscription.activeTo)"
            class="app-navbar__text"
            :style="{color: this.$themes.gray}"
          >
            {{ $t('dashboard.info.yourPlan') }} <strong><a @click="toSubscriptions">{{this.$store.getters.localUserSubscription.name}}</a></strong> {{ $t('dashboard.info.isActiveUntil') }} <strong>{{this.$store.getters.localCompanySubscription.activeTo | moment("MMMM Do YYYY")}}</strong>
          </span>

          <span v-if="this.$store.getters.localCompanySubscription.isExpired"
            class="app-navbar__text"
            :style="{color: this.$themes.gray}"
          >
            {{ $t('dashboard.info.yourPlanExpired') }} <va-button
              @click="toSubscriptions"
              color="#000000"
              class="app-navbar__button"
              :icon="this.$store.getters.subscription === null ? 'fa fa-unlock' : 'fa fa-star'"
            >
              {{ $t('dashboard.info.renew') }}
            </va-button>
          </span>
        </div>
        <!--        <p v-html="this.$store.getters.localUserSubscription.description"></p>-->
        <p><strong>{{ $t('dashboard.info.validUntil') }}: </strong> {{this.$store.getters.localCompanySubscription.activeFrom}} - {{this.$store.getters.localCompanySubscription.activeTo}}</p>
        <va-button @click="toSubscriptions" color="warning">
          {{ $t('dashboard.info.extendOrUpgrade') }}
        </va-button>
      </va-card>
    </div>
  </div>
</template>

<script>
import { getVerticalBarChartData } from '@/data/charts/VerticalBarChartData'
export default {
  name: 'DashboardInfoBlock',
  data () {
    return {
      limitStats: { },
      profits: { },
      subscriptionPacks: [],
      companySubscription: null,
      verticalBarChartData: null,
    }
  },
  methods: {
    async toSubscriptions () {
      await this.$router.push({
        name: 'subscriptions',
      })
    },
    isDayAfter (timestamp) {
      return this.$moment(Date.now()).isAfter(timestamp, 'days')
    },
    toLocations () {
      this.$router.push({
        name: 'locations',
      })
    },
    toClients () {
      this.$router.push({
        name: 'clients',
      })
    },
    toAppSettings () {
      this.$router.push({
        name: 'app-settings',
      })
    },
    toAppSubscriptions () {
      this.$router.push({
        name: 'app-subscriptions',
      })
    },
    limitByType (type) {
      const limit = this.$store.getters.localUserLimits.filter(item => {
        return item.name === type
      })
      const units = limit[0].units < 0 ? 'unlimited' : limit[0].units
      return units
    },
    async initDashboard (response) {
      this.limitStats = response
      this.verticalBarChartData = getVerticalBarChartData(this.$themes, response.byTime)
      // this.$store.commit('setLoading', false)
    },
    async initDashboardProfits (response) {
      this.profits = response
      // this.$store.commit('setLoading', false)
    },
  },
  computed: {
    currencySign () {
      return this.$store.getters.theCurrency.currencySign
    },
  },
  mounted () {
    // this.$store.commit('setLoading', false)
    this.$store.dispatch('getDashboardStats')
      .then((resp) => this.initDashboard(resp.data.message))
      .then(() => this.$store.dispatch('getDashboardProfitStats'))
      .then((resp) => this.initDashboardProfits(resp.data.message))
      .then(() => this.$store.dispatch('getSubscriptionPacks').then((resp) => {
        this.subscriptionPacks = resp.data.message
      }))
      .then(() => this.$store.dispatch('getCompanySubscription').then((resp) => {
        this.companySubscription = resp.data.message
      }))
      // eslint-disable-next-line handle-callback-err
      .catch((err) => {
      })
  },
}
</script>

<style lang="scss">
  .event_span {
    font-size: 10px;
    float: right;
    background: rgba(121, 121, 121, 0.5);
    padding: 5px;
    border-radius: 3px;
  }

  .icon_actions {
    float: right;
    background: rgba(121, 121, 121, 0.5);
    padding: 1px;
    margin-left: 5px;
    border-radius: 15px;
  }

  .icon_actions .va-button-group {
    margin: 0;
  }

  .va-collapse__body {
  }

  .realTimeClients {
    scroll-behavior: smooth;
    overflow: scroll;
    max-height: 90vh;
  }

  .limitTo {
    font-size: 15px;
    color: #cccccc;
  }

  .clickPointer {
    cursor: pointer;
  }

  .ceoMark {
    font-style: italic;
    font-size: 13px;
    color: #cccccc;
  }

  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2) {
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }

    .va-card__image {
      @include media-breakpoint-up(md) {
        padding-bottom: 0 !important;
      }
    }
  }
</style>
